/**
 * this file contains all redux-saga watchers & workers (like separate threads)
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Tom on 18/06/18
 */

import { all } from 'redux-saga/effects'

// import sagas
import * as TransactionSaga from './sagas/transactionSaga'
import * as InvestmentSaga from './sagas/investmentSaga'
import * as PortfolioSaga from './sagas/portfolioSaga'
import * as ComponentSaga from './sagas/componentSaga'
import * as ProfileSaga from './sagas/profileSaga'
import * as FundSaga from './sagas/fundSaga'
import * as NotificationsSaga from './sagas/notificationsSaga'
import * as DocumentsSaga from './sagas/documentsSaga'
import * as BillingSaga from './sagas/billingSaga'
import * as NewsSage from './sagas/latestnewsSaga'


/* -----------------------------------------------------------------------------
    ROOT SAGA
----------------------------------------------------------------------------- */

// this root saga groups all other watcher sagas together
export default function* rootSaga() {
    yield all([
        TransactionSaga.watchFetchTransaction(),
        TransactionSaga.watchClearDateRange(),
        ComponentSaga.watchOpenLeftMenu(),
        ProfileSaga.watchFetchProfile(),
        ProfileSaga.watchUpdateProfile(),
        InvestmentSaga.watchFetchInvestment(),
        PortfolioSaga.watchFetchPortfolio(),
        FundSaga.watchFetchFund(),
        NotificationsSaga.watchFetchNotifications(),
        NotificationsSaga.watchDismissNotification(),
        DocumentsSaga.watchFetchDocSignStatus(),
        DocumentsSaga.watchFetchDocumentsData(),
        BillingSaga.watchFetchBillingData(),
        NewsSage.watchFetchNewsData()
    ])
}



// WEBPACK FOOTER //
// ./src/sagas.js